/**
 * ast/core — construct a Babel/recast parser for a given file, choosing the
 * plugin set (typescript/tsx vs flow/jsx) from the file's language.
 */
import { parse as babelParse } from '@babel/parser';

import { parserPlugins } from '@/ast/core/parser-plugins/parser-plugins';
import getFileLanguage from '@/shared/utils/get-file-language';

export function createParser(fileKey: string) {
  const babelPlugins = [...parserPlugins];
  const language = getFileLanguage(fileKey);

  if (language === 'typescript') {
    babelPlugins.push('typescript');
    if (fileKey.endsWith('.tsx')) {
      babelPlugins.push('jsx');
    }
  } else {
    babelPlugins.push('flow', 'jsx');
  }

  return {
    parse: (code: string) =>
      babelParse(code, {
        sourceType: 'module',
        sourceFilename: fileKey,
        allowImportExportEverywhere: true,
        allowReturnOutsideFunction: true,
        tokens: true,
        plugins: babelPlugins,
      }),
  };
}
